import { FC } from 'react'

/**
 * * Icon Component for: diamond-shine
 */
type DiamondShineIconProps = {
  size?: number
  color?: string
}
export const DiamondShineIcon: FC<DiamondShineIconProps> = ({ size = '1rem', color = 'white', ...rest }) => {
  const iconAttributes = {
    width: size,
    height: size,
  }

  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...rest} {...iconAttributes} viewBox="0 0 16 16" fill="none">
      <mask id="mask0_4525_34366" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_4525_34366)">
        <path
          d="M8.00633 14.0667L2.72699 8.65002L5.72816 5.05652H10.2782L13.2795 8.65002L8.00633 14.0667ZM3.84483 4.88335L2.47949 3.52435L3.09233 2.90518L4.45766 4.26418L3.84483 4.88335ZM7.57316 3.85652V1.93335H8.43966V3.85652H7.57316ZM12.1513 4.88335L11.5448 4.27052L12.9038 2.91152L13.5167 3.52435L12.1513 4.88335ZM8.00633 12.818L11.7142 9.04618H4.29233L8.00633 12.818ZM6.13466 5.92302L4.24999 8.17952H11.7398L9.87183 5.92302H6.13466Z"
          fill={color}
        />
      </g>
    </svg>
  )
}
